import * as yup from 'yup';

export const hotmartSchema = yup.object().shape({
  client_id: yup.string().required('Este campo é obrigatório.'),
  client_secret: yup.string().required('Este campo é obrigatório.'),
  basic: yup.string().required('Este campo é obrigatório.'),
  provider_id: yup.string().required('Este campo é obrigatório.'),
});
